import ChannelListContext from '@shared/components/utils/context/channelListContext';
import ChannelListProgressBarContainer from '../../atoms/container/channelListProgressBarContainer';
import ChannelListProgressBarContent from '../../elements/progressBar/progressBarContent';
import ProgressUtils from '@shared/utils/progress';
import { updateEvents } from '@shared/store/thunks/events.thunk';
import { useAppDispatch } from '@shared/store/hooks';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';

const PROGRESS_UPDATE_TIME = 3 * 1000;

export default function ChannelListProgressBar() {
  const dispatch = useAppDispatch();
  const { event } = useContext(ChannelListContext);
  const [progress, setProgress] = useState(0);
  const intervalRef = useRef<ReturnType<typeof setTimeout>>();

  const { start, end, current } = useMemo(() => {
    const start = event?.date?.start || 1;
    const end = event?.date?.end || 1;
    const current = start < Date.now() && Date.now() < end;
    return { start, end, current };
  }, [event?.date]);

  useEffect(() => {
    setProgress(ProgressUtils.calculateProgressInTime(Date.now(), start, end));
    intervalRef.current = setInterval(() => {
      if (Date.now() > end) {
        dispatch(updateEvents(true));
      }
      setProgress(
        ProgressUtils.calculateProgressInTime(Date.now(), start, end)
      );
    }, PROGRESS_UPDATE_TIME);
    return () => clearInterval(intervalRef.current);
  }, [start, end]);

  return current ? (
    <ChannelListProgressBarContainer id={'channelListProgressBarContainer'}>
      <ChannelListProgressBarContent
        animate={false}
        duration={end}
        liveProgress={0}
        position={start}
        progress={progress}
        timeOnTop={true}
      />
    </ChannelListProgressBarContainer>
  ) : null;
}
